/* @flow */

import AddSupplierContactPersonRequest from 'models/requests/confirming/AddSupplierContactPersonRequest';
import CompanyContactPerson from 'models/companies/companyContactPerson';

export default class SupplierContactPersonForm {
  titleId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  languageId: number;
  functionName: string;
  personId: number;

  constructor(contactPerson: CompanyContactPerson) {
    if (!contactPerson) {
      this.titleId = 0;
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.languageId = 0;
      this.functionName = '';
      this.personId = 0;
    } else {
      this.titleId = contactPerson.titleId;
      this.firstName = contactPerson.firstName;
      this.lastName = contactPerson.lastName;
      this.email = contactPerson.email;
      this.languageId = contactPerson.languageId;
      this.functionName = contactPerson.functionName;
      this.personId = contactPerson.personId;
    }
  }

  toRequest(companyId: number, supplierCompanyId: number) {
    const request = new AddSupplierContactPersonRequest();
    request.companyId = companyId;
    request.supplierCompanyId = supplierCompanyId;
    request.titleId = this.titleId;
    request.firstName = this.firstName;
    request.lastName = this.lastName;
    request.email = this.email;
    request.phone = this.phone;
    request.languageId = this.languageId;
    request.functionName = this.functionName;
    request.personId = this.personId;
    return request;
  }
}
